import React, { Component } from 'react'
import style from './style.css'

import { Text } from '../../atoms/Forms'
import FontIcon from '../../atoms/FontIcon'

class InputIcon extends Component {
    render() {
      return (
        <div className={`${style.icon}`}>
            <Text
              handleChange={(e) => this.props.handleChange(e) || null}
              placeholder={this.props.placeholder}></Text>
              { this.props.iconAction ? (
                <a onClick={(e) => {
                  e.preventDefault()
                  this.props.iconAction()
                }}>
                  <FontIcon name={this.props.icon}></FontIcon>
                </a>              
              ) : (
                <FontIcon name={this.props.icon}></FontIcon>
              )}
        </div>
      )
    }
  }
  
  export default InputIcon


// WEBPACK FOOTER //
// ./src/components/molecules/InputIcon/index.js